<template>
    <div class="page search-new">
        <div class="search-new-search_input">
            <van-search
                ref="search_input"
                v-model="searchText"
                :autofocus="autofocus"
                show-action
                clear-trigger="always"
                @search="onSearch"
                @cancel="onCancel"
                @input="onInput"
                placeholder="搜一搜"
            >
                <template v-slot:left-icon>
                    <img src="/static/bytx/search_icon.svg" alt="" style="margin-top: 2px" />
                </template>
                <template slot="action">
                    <div class="search-list-btn" @click="onSearch">搜索</div>
                </template>
            </van-search>
        </div>
        <div class="search-new-history" v-if="showHistory">
            <div class="search-new-history-title">
                <div class="search-new-history-title-left">
                    <span>历史搜索</span>
                </div>
                <div class="search-new-history-title-right" @click="delDialog = true">
                    <span>删除</span>
                    <img src="/static/bytx/search_delete.svg" alt="" />
                </div>
            </div>
            <div class="search-new-history-content">
                <div class="search-new-history-content-top" :class="[textToggle ? '' : 'active']" ref="historyRef">
                    <span
                        v-for="(item, index) in historyTag"
                        :key="index"
                        ref="tagRef"
                        @click="clickTag(item)"
                        :class="[item.title === '展开' || item.title === '收起' ? 'chu' : '']"
                        v-if="item.title"
                    >
                        {{ item.title }}
                        <img v-if="item.title === '展开'" src="/static/bytx/subject/more_down.svg" alt="" />
                        <img v-if="item.title === '收起'" src="/static/bytx/subject/more_up.svg" alt="" />
                    </span>
                </div>
            </div>
        </div>
        <div class="search-new-result" v-if="showResult">
            <van-tabs v-model="searchClassify" @click="tabClick">
                <van-tab
                    v-for="(item, index) in searchClassifyArr"
                    :title="item.name"
                    :key="index"
                    :name="item.type"
                    :title-class="index == searchClassifyArr.length - 1 ? 'van-last' : ''"
                ></van-tab>
            </van-tabs>
<!--            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">-->
                <van-list v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                    <!-- <content-selection :recommend="recommend"></content-selection> -->
                    <ContentSelection :dataItem="recommend" :contentType="2" :searchText="searchText"/>
                </van-list>
<!--            </van-pull-refresh>-->
        </div>
        <div class="search-new-empty" v-if="searchResultEmpty">
            <van-empty description="" image="/static/img/pic_blank_search.svg" />
            <div class="search-new-empty-desc1">
                换个词，搜搜看
            </div>
            <!--      <div class="search-new-empty-desc2">-->
            <!--        可重新搜索别的内容试试-->
            <!--      </div>-->
            <div class="search-new-empty-back">
                <span @click="$router.push('/')">返回首页</span>
            </div>
        </div>
        <div class="search-new-hot" v-if="showHot">
            <div class="search-new-hot-title">
                <img src="/static/bytx/search_hot.svg" />
            </div>
            <div class="search-new-hot-content">
                <div class="search-new-hot-content-left">
                    <div
                        class="search-new-hot-content-left-item"
                        v-for="(i, index) in hotLeftArr"
                        :key="index"
                        @click="clickHot(i)"
                    >
                        <div class="search-new-hot-content-left-item-l">
                            <span :class="[index < 3 ? `span${index + 1}` : '']">{{ index + 1 }}</span>
                        </div>
                        <div class="search-new-hot-content-left-item-r">
                            <span>{{ i.title }}</span>
                            <!--              <span v-if="index < 3">热</span>-->
                        </div>
                    </div>
                </div>
                <div class="search-new-hot-content-right">
                    <div
                        class="search-new-hot-content-left-item"
                        v-for="(i, index) in hotRightArr"
                        :key="index"
                        @click="clickHot(i)"
                    >
                        <div class="search-new-hot-content-right-item-l">
                            <span v-if="hotArr.length == 2" :class="[hotArr.length == 2 ? `span${hotArr.length}` : '']">
                                {{ index + 1 + hotLeftArr.length }}</span
                            >
                            <span
                                v-else-if="hotArr.length == 3 || hotArr.length == 4"
                                :class="[hotArr.length == 3 || hotArr.length == 4 ? `span${index}` : '']"
                            >
                                {{ index + 1 + hotLeftArr.length }}</span
                            >
                            <span v-else>{{ index + 1 + hotLeftArr.length }}</span>
                        </div>
                        <div class="search-new-hot-content-right-item-r">
                            <span>{{ i.title }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="search-new-list" v-if="showList">
            <ul>
                <li v-for="(item, index) in searchList" :key="index" @click="selectItem(item)">
                    <img src="/static/bytx/search_icon.svg" alt="" />
                    <span>{{ item.title }}</span>
                </li>
            </ul>
        </div>
        <van-dialog
            v-model="delDialog"
            className="mDialog"
            title="删除确定"
            message="确定全部历史记录吗？"
            :showCancelButton="true"
            @confirm="delConfirm"
        ></van-dialog>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import ContentSelection from '@/components/contentSelection/index.vue'
export default {
    name: 'search',
    components: {
        ContentSelection
    },
    data() {
        return {
            searchText: '',
            autofocus: false, // 是否自动聚焦
            historyTag: [],
            textToggle: true,
            showToggle: false,
            delDialog: false,
            hotArr: [],
            hotLeftArr: [],
            hotRightArr: [],
            searchList: [],
            showList: false,
            searchResultEmpty: false,
            searchClassify: null,
            searchClassifyArr: [
                { id: 1, name: '全部' },
                { id: 2, name: '抗癌百科' },
                { id: 3, name: '医疗服务' },
                { id: 4, name: '公益救助' },
                { id: 5, name: '战友故事' },
                { id: 6, name: '看直播' }
            ],
            showResult: false,
            recommend: [],
            title: '',
            toggleTop: 0,
            line: 0,
            hideIndex: 0,
            listLoading: false,
            finished: false,
            refreshing: false,
            pageNum: 2,
            showHot: false,
            showHistory: false
        }
    },
    beforeRouteEnter(to, from, next) {
        to.meta.keepAlive = true
        next(vm => {
            if (from.name == 'home') {
                vm.searchText = ''
            }
        })
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            Interface.getData('get', Interface.history_search).then(res => {
                if (res.code == 0) {
                    this.historyTag = res.data.histories
                    this.hotArr = res.data.hot_words
                    if (this.historyTag && this.historyTag.length) {
                        this.showHistory = true
                    }
                    this.defaultClose()
                    if (this.hotArr.length > 0) {
                        if (this.hotArr.length % 2 === 0) {
                            this.hotLeftArr = this.hotArr.filter((item, index) => {
                                return index < this.hotArr.length / 2
                            })
                            this.hotRightArr = this.hotArr.filter((item, index) => {
                                return index >= this.hotArr.length / 2
                            })
                        } else {
                            this.hotLeftArr = this.hotArr.filter((item, index) => {
                                return index < this.hotArr.length / 2
                            })
                            this.hotRightArr = this.hotArr.filter((item, index) => {
                                return index > this.hotArr.length / 2
                            })
                        }
                        this.showHot = true
                    }
                }
            })
        },
        onSearch(arg) {
            if (Object.prototype.toString.call(arg) === '[object PointerEvent]') {
              arg = null
            }
            this.showList = false
            this.historyTag = []
            let searchClassify = null
            let pageType = this.$route.query.pageType ? this.$route.query.pageType : 0
            Interface.mFootPrint(0,77,0,pageType,0,0,0,this.searchText)
            Interface.getData('get', Interface.content_recommend_type, { keyword: this.searchText }).then(res => {
                if (res.code == 0) {
                    this.searchClassifyArr = res.data && res.data.length ? res.data : []
                    if (this.searchClassifyArr && this.searchClassifyArr.length) {
                        searchClassify = arg || this.searchClassifyArr[0].type
                    }
                    Interface.getData('get', Interface.content_recommend, {
                        keyword: this.searchText,
                        type: searchClassify,
                        page: 1,
                        pageSize: 10
                    }).then(res => {
                        if (res.code == 0) {
                            if (res.data.list && res.data.list.length) {
                                this.showResult = true
                                this.recommend = res.data.list
                                // Interface.mFootPrint(0,67,2,1,0,0,0,this.searchText)
                            } else {
                                this.searchResultEmpty = true
                                this.showHot = true
                                this.showResult = false
                                Interface.mFootPrint(0,75,0,1,0,0,0,this.searchText)
                            }
                        }
                    })
                }
            })
        },
        onCancel() {},
        onInput(val) {
            if (val) {
                Interface.getData('get', Interface.course.hot_search, { keyword: val }).then(res => {
                    if (res.code == 0) {
                        this.searchList = res.data
                    }
                })
            }
        },
        // 删除搜索历史
        delConfirm() {
            Interface.getData('delete', Interface.course.del_hot_word).then(res => {
                if (res.code == 0) {
                    this.historyTag = []
                    this.showHistory = false
                }
            })
        },
        // 点击某个历史搜索
        clickTag(item) {
            // console.log('item====', item.title)
            if (item.title === '展开') {
                this.openAll()
            } else if (item.title === '收起') {
                this.defaultClose()
            } else {
                this.searchText = item.title
                this.autofocus = true
                this.$nextTick(() => {
                    this.showList = false
                })
                this.onSearch()
            }
        },
        // 历史搜索默认收起
        defaultClose() {
            this.$nextTick(() => {
                if (!this.historyTag || !this.historyTag.length) {
                    return
                }
                let offsetLeft = 0
                this.line = 0
                let tags = this.$refs.tagRef
                tags.forEach((item, index) => {
                    if (index === 0) {
                        this.line = 1
                        offsetLeft = item.offsetLeft
                    } else if (item.offsetLeft === offsetLeft) {
                        this.line++
                    }
                    // if (this.line === 3) {
                    //   this.hideIndex = index - 1
                    //   console.log('this.hideIndex====', this.hideIndex)
                    // }
                    if (this.line > 1) {
                        item.style.marginTop = 12 + 'px'
                    }
                    if (this.line > 2) {
                        item.style.display = 'none'
                        if (item.className === 'chu') {
                            item.style.display = 'inline-block'
                            item.style.marginTop = 0 + 'px'
                        }
                        //  tags[this.hideIndex].style.display = 'none'
                    }
                })
                if (this.line > 2) {
                    this.historyTag.push({ id: 0, title: '展开' })
                }
                let index = this.historyTag.findIndex(item => {
                    return item.title === '收起'
                })
                if (index > -1) {
                    this.historyTag.splice(index, 1)
                }
            })
        },
        // 历史搜索展开
        openAll() {
            let tags = this.$refs.tagRef
            let index = this.historyTag.findIndex(item => {
                return item.title === '展开'
            })
            this.historyTag.splice(index, 1)
            this.historyTag.splice(tags.length, 0, { id: 0, title: '收起' })
            tags.forEach((item, index) => {
                item.style.display = 'inline-block'
            })
        },
        // 点击某个热门搜索
        clickHot(item) {
            this.searchText = item.title
            this.autofocus = true
            this.$nextTick(() => {
                this.showList = false
            })
            // 热词点击量
            Interface.getData('get', Interface.course.hot_click + '/' + item.id + '/view').then(res => {
                // console.log('===', res.data)
            })
          // Interface.footPrint1(61, item.id)
          Interface.mFootPrint(item.id,61,0,1,0,0,0,this.searchText)
            this.onSearch()
        },
        // 选中模糊搜索列表的某一个
        selectItem(item) {
            this.searchText = item.title
            this.autofocus = true
            this.$nextTick(() => {
                this.showList = false
            })
            this.onSearch()
        },
        tabClick(name, title) {
            console.log('name====', name, title, this.searchClassify)
            this.pageNum = 2
            this.finished = false
            this.onSearch(this.searchClassify)
        },
        onLoad() {
            Interface.getData('get', Interface.content_recommend, {
              keyword: this.searchText,
              type: this.searchClassify || 0,
              page: this.pageNum, pageSize: 10 }).then(res => {
                if (res.code == 0) {
                    this.listLoading = false
                    if (res.data.list && res.data.list.length) {
                        this.pageNum++
                        this.recommend = this.recommend.concat(res.data.list)
                    } else {
                        this.finished = true
                    }
                    // if (this.pageNum  > 131) {
                    //   this.finished = true;
                    // }
                }
            })
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.listLoading = true
            this.onLoad()
        }
    },
    watch: {
        searchText: {
            handler(newVal, oldVal) {
                console.log('newVal=====', newVal)
                if (newVal) {
                    this.showHistory = false
                    this.showHot = false
                    this.showList = true
                    // this.showResult = false
                } else {
                    this.showList = false
                    this.init()
                    this.searchResultEmpty = false
                    this.showResult = false
                    this.searchClassify = null
                    this.finished = false
                    this.pageNum = 2
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import './index';
</style>



// WEBPACK FOOTER //
// src/views/search-new/index.vue